// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__ANdA0","lds-ripple":"Loader_lds-ripple__3Fwqm","center":"Loader_center__Iyafz"};